module.exports = __webpack_public_path__ + "img/avbuilder_upload.60f8663d.svg";